export default "__VITE_ASSET__LZ_MHhyB__"